import {
  trigger,
  transition,
  style,
  animate,
  state,
  group
} from '@angular/animations';

export const rollDown = trigger('rollDown', [
  transition('void => *', [
    style({
      top: '-100%'
    }),
    animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')
  ]),
  transition('* => void', [
    animate('80ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
    style({
      bottom: '-100%'
    })
  ])
]);

export const fading = trigger('fading', [
  transition('void => *', [
    style({
      opacity: 0,
    }),
    animate('250ms cubic-bezier(0.4, 0.0, 0.2, 1)')
  ]),
  transition('* => void', [
    animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({
      opacity: 0,
    }))
  ])
])

export const expandHorizontal = trigger('expandHorizontal', [
  transition('void => *', [
    style({
      opacity: 0,
      width: 0
    }),
    animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')
  ]),
  transition('* => void', [
    animate('80ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
    style({
      opacity: 0,
      width: 0
    })
  ])
]);

export const expandVertical = trigger('expandVertical', [
  transition('void => *', [
    style({
      opacity: 0,
      height: 0
    }),
    animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')
  ]),
  transition('* => void', [
    animate('80ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
    style({
      opacity: 0,
      height: 0
    })
  ])
]);

export const expandSize = trigger('expandSize', [
  transition('void => *', [
    style({
      opacity: 0,
      width: 0,
      height: 0
    }),
    animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')
  ]),
  transition('* => void', [
    animate('80ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
    style({
      opacity: 0,
      width: 0,
      height: 0
    })
  ])
]);

export const SlideInOutAnimation = [
  trigger('slideInOut', [
      state('in', style({
          'max-height': '500px', 'opacity': '1', 'visibility': 'visible'
      })),
      state('out', style({
          'max-height': '0px', 'opacity': '0', 'visibility': 'hidden'
      })),
      transition('in => out', [group([
          animate('400ms ease-in-out', style({
              'opacity': '0'
          })),
          animate('600ms ease-in-out', style({
              'max-height': '0px'
          })),
          animate('700ms ease-in-out', style({
              'visibility': 'hidden'
          }))
      ]
      )]),
      transition('out => in', [group([
          animate('1ms ease-in-out', style({
              'visibility': 'visible'
          })),
          animate('600ms ease-in-out', style({
              'max-height': '500px'
          })),
          animate('800ms ease-in-out', style({
              'opacity': '1'
          }))
      ]
      )])
  ]),
]



// WEBPACK FOOTER //
// ./src/animations/appear-animation.ts